module.exports = __webpack_public_path__ + "static/media/icon-video.800a3338.svg";